"use client";

import { useTranslations } from "next-intl";
import { cn } from "@/lib/cn";

export interface FilterPillButtonProps {
  count: number;
  onClick: () => void;
  disabled?: boolean;
  /** Collapse the label to icon-only below `sm`; the aria-label keeps the name. */
  hideLabelOnMobile?: boolean;
  className?: string;
}

/** Header "Filters" pill: filter-lines icon + label + active-count badge. */
export function FilterPillButton({
  count,
  onClick,
  disabled,
  hideLabelOnMobile,
  className,
}: FilterPillButtonProps) {
  const t = useTranslations("filters");
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={t("title")}
      className={cn(
        "relative flex h-10 items-center gap-2 rounded-full border border-white/12 bg-white/[0.04] px-4 text-sm font-medium text-white/80 backdrop-blur-md transition-colors hover:border-white/20 hover:text-white disabled:opacity-40",
        className,
      )}
    >
      <svg viewBox="0 0 24 24" className="size-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <path d="M3 5h18M6 12h12M10 19h4" />
      </svg>
      <span className={hideLabelOnMobile ? "hidden sm:inline" : undefined}>{t("title")}</span>
      {count > 0 && (
        <span className="flex size-5 items-center justify-center rounded-full bg-flamingo text-2xs font-bold text-white">
          {count}
        </span>
      )}
    </button>
  );
}
